import React from 'react';

import EnrollmentSolicitationTable from '../EnrollmentTable';

import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <EnrollmentSolicitationTable />
    </div>
  );
};
